import clsx from 'clsx'

export type OptionChipColorName =
  'blue' |
  'green' |
  'orange' |
  'pink' |
  'purple' |
  'red' |
  'yellow'

export type OptionChipProps = {
  label: string
  width?: number
  inOverlay?: boolean
  color?: OptionChipColorName
}

export const optionChipColorNames: OptionChipColorName[] = [
  'blue',
  'green',
  'orange',
  'pink',
  'purple',
  'red',
  'yellow'
]

export function OptionChip (props: OptionChipProps) {
  const { label, width, color, inOverlay } = props

  return (
    <div
      className={clsx(
        'rounded-lg',
        'py-1',
        'px-2',
        'font-semibold',
        'leading-3',
        'text-xs',
        'h-6',
        'whitespace-nowrap',
        `field-type-select-${color}`,
        { truncate: Boolean(inOverlay) },
        { [`max-w-${width! - 48}`]: Boolean(width) }
      )}
    >
      <span className="text-xs truncate p-0 m-0">
        {label}
      </span>
    </div>
  )
}
